import React, { ReactChild } from 'react';
import { createStyles, Dialog, DialogContent, Icon, IconButton, makeStyles, Theme, Typography } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';

interface IBasicDialog {
    handleClose?: () => void,
    title: string,
    description: string,
    open: boolean,
    children: ReactChild       
}

const useStyles = makeStyles((theme: Theme) => createStyles({    
    closeButton: {
        position: 'absolute',
        right: theme.spacing(3),
        top: theme.spacing(3),
        color: theme.palette.text.secondary,
    },
    titleWrapper: {
        paddingLeft: 0
    },
    description: {
        color: theme.palette.text.secondary,
        marginTop: '8px'
    },
}));

export function BasicDialog({handleClose, title, description, open, children}: IBasicDialog) {
    const classes = useStyles();

    function DialogTitle() {
        return (
            <MuiDialogTitle disableTypography className={classes.titleWrapper}>
                <Typography variant="h4">{title}</Typography>
                <Typography variant="body2" className={classes.description}>{description}</Typography>
                {handleClose ? (
                    <IconButton onClick={handleClose} className={classes.closeButton}>
                        <Icon aria-label="close">close</Icon>
                    </IconButton>
                ) : null}
            </MuiDialogTitle>
        );
    }

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogContent>
                <DialogTitle/>
                {children}
            </DialogContent>
        </Dialog>
    );
}